import { mapActions } from 'vuex';

import { ADD_TO_CART } from '../store/actions';
import { CLIP_TYPE_CODE } from '../config';

import AddToCart from './add-to-cart/add-to-cart.vue';
import SpinnerBtn from './common/spinner-btn/spinner-btn.vue';

export default {
   props: {
      info: { type: Object, required: true }
   },
   data() {
      return { loading: false };
   },
   components: { AddToCart, SpinnerBtn },
   computed: {
      duration() {
         return this.info.duration;
      },
      isClip() {
         return this.info.type === CLIP_TYPE_CODE;
      }
   },
   methods: {
      ...mapActions({
         addToCart: ADD_TO_CART
      }),
      goto(e) {
         if ( this.showOverlay === false ) {
            this.$emit('click');
            return;
         }

         if ( !this.$refs.gotoClipEditorBtn && !this.$refs.addToCartBtn && !this.$refs.downloadBtn ) {
            return;
         }

         const btn = this.$refs.gotoClipEditorBtn || this.$refs.downloadBtn || this.$refs.addToCartBtn.$el ;

         if (btn === e.target || btn.contains(e.target)) {
            return;
         }

         this.$emit('click');
      },
      makeClip() {
         let eid = this.info.id;
         const mid = this.$route.params.mid;
         const params = { mid, eid };
         this.$router.push({name: 'ClipMaker', params });
      },
      async addTo(cart) {
         this.loading = true;
         const clip = this.info;
         await this.addToCart({ cart, clip });
         this.loading = false;
      }

   }
};
